module.exports = "/images/attach-files.png?4f56403c1a99961957ebb9e8c6f9bc82";